import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function Landing() {
  return (
    <Box sx={{ mx: 1, my: 3 }}>
      <Typography variant="h3" sx={{ pl: 4 }}>
        Dashboard
      </Typography>
      <br />
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <ArrowBackIcon color="text.secondary" />
        <Stack>
          <Typography variant="h5">Please select an app to view from the sidebar</Typography>
          <Typography variant="h5">
            If you don&apos;t see the application you are looking for, ask admin for permissions
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default React.memo(Landing);
